import { Component, OnInit } from '@angular/core';
import {ActivatedRoute, Router} from '@angular/router';
import { Subscription } from 'rxjs/Subscription';
import { DatabaseService } from '../../../providers/database.service';
import { FirebaseApp } from 'angularfire2';
import {FormBuilder, FormGroup, Validators} from '@angular/forms';

@Component({
  selector: 'app-fiche',
  templateUrl: './fiche.component.html',
  styleUrls: ['./fiche.component.scss']
})
export class FicheComponent implements OnInit {

  public sub: Subscription;
  public user: any;
  public devis: any;
  public comment: any;
  public commandes: FormGroup;
  constructor(private route: ActivatedRoute,
              private fb: FirebaseApp,
              public db: DatabaseService,
              public formBuilder: FormBuilder,
              private router: Router) {
    this.commandes = this.formBuilder.group({
      message: ['', Validators.required]
    });

  }

  ngOnInit() {
    this.sub = this.route.params.subscribe(params => {
      this.db.getUser(params).valueChanges().forEach(user => {
        this.user = user;
        this.db.getmydevis(this.user['uid']).valueChanges().forEach( devis => {
          console.log(devis);
          this.devis = devis;
        });
        this.db.getmycomment(this.user['uid']).valueChanges().forEach( comment => {
          console.log(comment);
          this.comment = comment;
        });
      });
    });
  }

  deleteDevis(uid) {
    this.db.deleteDevis(this.user['uid'], uid);
  }

  deleteComment(uid) {
    this.db.deleteComment(this.user['uid'], uid);
  }

  uploadFile(event, uid) {
    const storageRef = this.fb.storage().ref();
    const file = event[0];
    const name = file.name;
    const metadata = {
      contentType: event.type
    };

    storageRef.child('devis/' + name).put(file, metadata).then( data => {
        this.db.addfield(uid, {
          name: name,
          link: data['metadata'].downloadURLs[0]
        });
      });
  }

  addComment(uid) {
    this.db.addComment(uid, this.commandes.value);
  }

  goBack() {
    this.router.navigate(['/admin/']);
  }

}



// WEBPACK FOOTER //
// /Users/Mustafa/Developpement/noxoe/src/components/admin/fiche/fiche.component.ts